var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_bottom"},[_c('div',{staticClass:"bottom_one"},[_c('div',{staticClass:"hotel-logo"},[_c('span',{staticClass:"logo-img"})]),_c('div',{staticClass:"address"},[_vm._v("Jr.Las Mandiocas Mza.E,lote 18 Urb San Ignacio,San Juan de Lurigancho,Provincia y departamento de Lima")])])])
}]

export { render, staticRenderFns }